import React, { useRef, useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import { Outlet, useNavigate } from 'react-router-dom';
import Header from './Header';
import { useDispatch, useSelector } from 'react-redux';
import UpdatePasswordForm from './updatePasswordForm';
import { InfinitySpin } from 'react-loader-spinner';
import { clearAuthData, logoutState } from '../../Redux/AuthSlice';
import { api_url } from '../../config';
import api from '../../utils/api';
import { toast } from 'react-toastify';
import { toggleSidebar, setSidebarVisibility } from '../../Redux/SidebarToggleSlice';
import { FiChevronLeft } from "react-icons/fi";
import { FiChevronRight } from "react-icons/fi";

const Layout = () => {
    const isSidebarVisible = useSelector((state) => state.sidebar.isSidebarVisible);
    const [isLargeScreen, setIsLargeScreen] = useState(false);
    const { loading, reset_password } = useSelector((state) => state.auth);
    const [modal, setModal] = useState(reset_password);
    const modalRef = useRef();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { token } = useSelector((state) => state.auth);

    useEffect(() => {
        const handleResize = () => {
            const largeScreen = window.innerWidth >= 1024;
            setIsLargeScreen(largeScreen);
            dispatch(setSidebarVisibility(largeScreen));
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [dispatch]);

    const handleLogout = async () => {
        try {
            dispatch(logoutState(true));
            await api.post(`${api_url}/api/wholesaler/logout`, {}, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            dispatch(clearAuthData());
            window.history.pushState(null, '', '/login');
            window.onpopstate = () => {
                window.history.pushState(null, '', '/login');
            };
            dispatch(logoutState(false));
            toast('Login again with updated password');
            navigate('/login', { replace: true });
        } catch (error) {
            console.error('Logout error:', error);
        }
    };

    return (
        <div className="relative flex flex-col h-screen overflow-hidden">
            {/* Sidebar */}
            <div
                className={`
          fixed top-0 left-0 h-full
          bg-[#0E1B31] p-4 font-lufga
          transition-all duration-300 ease-in-out
          w-[250px]
          ${isSidebarVisible ? 'translate-x-0' : '-translate-x-full'}
          ${isLargeScreen ? '' : 'absolute'}
          z-40 
        `}
            >
                <Sidebar />
            </div>

            {!isLargeScreen && isSidebarVisible && (
                <div
                    onClick={() => dispatch(toggleSidebar())}
                    className="fixed inset-0 z-30 transition-opacity duration-300 bg-black bg-opacity-50"
                />
            )}



            {/* Main Wrapper */}
            <div
                className={`
          flex flex-col flex-grow h-full transition-all duration-300 ease-in-out
        
          ${isLargeScreen && isSidebarVisible ? 'translate-x-[250px]' : 'translate-x-0'}
         ${isLargeScreen && isSidebarVisible ? 'pr-[250px]' : ''} 
          
        `}
            >
                {/* Header */}
                <Header
                    className="fixed top-0 left-0 right-0 z-20"
                    isSidebarVisible={isSidebarVisible}
                    toggleSidebar={() => dispatch(toggleSidebar())}
                />

                {/* Main Content */}
                <div className="relative flex flex-col flex-grow overflow-auto">
                    <div className="flex-grow px-2 overflow-auto pt-[30px]">
                        <Outlet context={{ isSidebarVisible, toggleSidebar: () => dispatch(toggleSidebar()) }} />
                    </div>
                </div>
            </div>

            {/* Loading Overlay */}
            {loading && (
                <div className="absolute inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-opacity-40 to-opacity-60 backdrop-blur-sm">
                    <div className="flex flex-col items-center gap-4">
                        <InfinitySpin color="#387ADF" size={32} />
                        <p className="text-center">Logging Out....</p>
                    </div>
                </div>
            )}

            {/* Modal */}
            {(!modal || modal === '0') && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-opacity-100 bg-neutral-800">
                    <div ref={modalRef} className="p-6 bg-white rounded-md shadow-lg min-h-max">
                        <UpdatePasswordForm setModal={setModal} modal={modal} handleLogout={handleLogout} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Layout;
